// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import dataTableStyles from "@guestsupply/App/SharedStyles/MyAccountPages/List/DataTableStyles";
import myAccountFilterSectionStyles from "@guestsupply/App/SharedStyles/MyAccountPages/List/MyAccountFilterSectionStyles";
import { autoDeliveryPaginationStyles } from "@guestsupply/App/Widgets/AutoDelivery/AutoDeliveryPagination";

import Close from "@guestsupply/XDL/Icons/Close";
import { createLinkIconStyles, mergeWithCss, xScreen } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

autoDeliveryPaginationStyles.container = {
    css: css`
        overflow: auto;
    `,
};


autoDeliveryPaginationStyles.paginationWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
    `,
};

